import * as Sentry from '@sentry/browser';
import config from '../config';

const { ipgeolocation } = config.thirdParty;

const DEFAULT_FIELD_OPTIONS = 'latitude, longitude, country_code2';

const getGeolocationByIP = async (fieldOptions: string = DEFAULT_FIELD_OPTIONS) => {
  let requestUrl = `${ipgeolocation.url}?fields=${fieldOptions}`;

  if (ipgeolocation.token) {
    requestUrl += `&apiKey=${config.thirdParty.ipgeolocation.token}`;
  }

  try {
    const response = await fetch(requestUrl);

    if (response.ok) {
      return await response.json();
    }

    throw new Error('Failed to retrieve geolocation by IP, invalid response');
  } catch (err) {
    Sentry.captureException(err);

    return { error: err };
  }
};

export default getGeolocationByIP;
